import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type OrderFulfillmentReducedFragment = { __typename?: 'OrderFulfillment', id: string, status: Types.OrderFulfillmentStatus, is_billable: boolean, event_id: string, type: string, timestamp: string, authorized_signer_id?: string | null, authorized_signer_name?: string | null, created_by_id: string, created_by_name: string, event: { __typename?: 'Event', id: string, name?: string | null, is_deleted: boolean }, assets: Array<{ __typename?: 'TrackableItem', id: string }>, container_stations: Array<{ __typename?: 'OrderFulfillmentContainerStation', id: string, name: string, returned_sealed: boolean, containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }> }>, single_containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, item_location: { __typename?: 'ItemLocation', id: string, name: string }, event_account: { __typename?: 'EventAccount', id: string, name?: string | null, is_billable: boolean, is_deleted: boolean } };

export const OrderFulfillmentReducedFragmentDoc = gql`
    fragment OrderFulfillmentReduced on OrderFulfillment {
  id
  status
  is_billable
  event_id
  event {
    id
    name
    is_deleted
  }
  type
  timestamp
  assets {
    id
  }
  container_stations {
    id
    name
    returned_sealed
    containers {
      container_id
      container_type_id
      container_type_name
      container_type_image
    }
    manual_amounts {
      container_type_id
      container_type_name
      container_type_image
      amount
      amount_sealed
    }
  }
  single_containers {
    container_id
    container_type_id
    container_type_name
    container_type_image
  }
  goodwill {
    container_type_id
    container_type_name
    container_type_image
    amount
    amount_sealed
  }
  manual_amounts {
    container_type_id
    container_type_name
    container_type_image
    amount
    amount_sealed
  }
  item_location {
    id
    name
  }
  event_account {
    id
    name
    is_billable
    is_deleted
  }
  authorized_signer_id
  authorized_signer_name
  created_by_id
  created_by_name
}
    `;